module.exports = __webpack_public_path__ + "826e58ab5988fa5c2099c4a872715478.svg";